import { ArticleHeading4, Image, UIText1, UIText2, Avatar } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SubAgentSearchItem.css';
import { TSubAgent } from '../../types/subAgent';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

type TSubAgentSearchItemProps = {
  subAgent: TSubAgent;
  onClick: (subAgentId: number) => void;
};

export const SubAgentSearchItem: React.FC<TSubAgentSearchItemProps> = ({ subAgent, onClick }) => {
  const { name, phones, totalUnreadMessagesCount, agentAvatarUrl, userId } = subAgent;

  const formatPhone = React.useMemo(() => {
    return phones && formatPhoneNumber(phones[0]);
  }, [phones]);

  return (
    <div className={styles['container']} onClick={() => onClick(userId)}>
      {agentAvatarUrl ? (
        <Image
          src={agentAvatarUrl}
          alt="Фотография пользователя"
          borderRadius="50%"
          objectFit="cover"
          height={56}
          width={56}
        />
      ) : (
        <div className={styles['avatar']} data-name="SubAgentSearchItem_avatar">
          <Avatar size={56} type="user" />
        </div>
      )}
      <div className={styles['info']}>
        <ArticleHeading4 data-name="SubAgentSearchItem_name">{name || `id ${userId}`}</ArticleHeading4>
        {formatPhone ? (
          <UIText1 color="gray60_100" data-name="SubAgentSearchItem_phone">
            {formatPhone}
          </UIText1>
        ) : null}
      </div>
      {totalUnreadMessagesCount ? (
        <span className={styles['counter']} data-name="SubAgentSearchItem_counter">
          <UIText2 color="text-inverted-default">{totalUnreadMessagesCount}</UIText2>
        </span>
      ) : null}
    </div>
  );
};
